var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_722_5913",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H0V18H18V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_722_5913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.77405 2.25L8.77405 6",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.774 2.25L8.77405 6",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.02405 6H15.524",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.884 6.87806L8.781 15.7501L1.679 6.87806C1.563 6.74212 1.49927 6.56927 1.49927 6.39056C1.49927 6.21185 1.563 6.039 1.679 5.90306L4.799 2.49806C4.87027 2.41883 4.95763 2.35573 5.05523 2.31297C5.15284 2.2702 5.25845 2.24875 5.365 2.25006H12.199C12.3048 2.24919 12.4096 2.27076 12.5065 2.31333C12.6033 2.35591 12.6901 2.41852 12.761 2.49706L15.855 5.89706C15.9753 6.02939 16.0443 6.20029 16.0498 6.37902C16.0553 6.55775 15.9969 6.73258 15.885 6.87206L15.884 6.87806Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedIcon);
export default __webpack_public_path__ + "static/media/featured-icon.d842bbfe1ad517354891f8bc7191f05a.svg";
export { ForwardRef as ReactComponent };